import * as core from '../../../../../../../core'

import { query } from './value-of-change-by-epic.query'

export const RESOURCE = {
  payload: {
    alias: 'value.of.change.by.epic',
    description: 'Chart view of value of change by epic',
    name: 'Value of Change by Epic',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
